import { observer } from "mobx-react-lite";
import { Form, Input, Modal, Button, Select } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import WhiteListStore from "../../../../stores/Admin/WhiteListStore";
import { isValidPhoneNumber } from "../../../../utils/regExp";
import UserStore from "../../../../stores/Admin/UserStore";
const { Option } = Select;
export interface RoleAddDialogProps {
  visible: boolean;
  close: () => void;
}

const WhitePhoneAddDialog: React.FC<RoleAddDialogProps> = (props) => {
  const [form] = Form.useForm();
  const [roleId, setRoleId] = useState<number>(0);
  useEffect(() => {
    form.resetFields();
  }, [props.visible]);
  useEffect(() => {
    setRoleId(UserStore.roleList[0]?.id);
  }, [UserStore.roleList]);
  const handleCheckPhone = (rule: any, value: any, callback: any) => {
    if (!value) {
      callback();
    }
    isValidPhoneNumber(value) ? callback() : callback("手机号码格式错误");
  };
  const submit = () => {
    form
      .validateFields()
      .then((res) => {
        console.log(res);
        const { phone } = form.getFieldsValue();
        WhiteListStore.addWhitePhone(phone, String(roleId));
        props.close();
      })
      .catch((err) => {});
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 20 },
    },
  };
  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: { span: 24, offset: 0 },
      sm: { span: 20, offset: 4 },
    },
  };
  return (
    <Modal
      forceRender
      title="添加手机号码"
      visible={props.visible}
      onCancel={props.close}
      onOk={submit}
      okText="确认"
      cancelText="取消"
    >
      <Form
        form={form}
        name="dynamic_form_item"
        {...formItemLayoutWithOutLabel}
      >
        <Form.Item label="默认分组" {...formItemLayout} name="roleId">
          <Select
            size="middle"
            placeholder="分组管理"
            key={UserStore.roleList[0]?.name}
            defaultValue={UserStore.roleList[0]?.name}
            onChange={(v) =>
              setRoleId(
                UserStore.roleList.filter((item) => item.name === v)[0].id
              )
            }
            style={{ width: "50%" }}
          >
            {UserStore.roleList.map((item) => (
              <Option key={item.name}>{item.name} </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.List
          name="phone"
          rules={[
            {
              validator: async (_, names) => {
                if (!names) {
                  return Promise.reject(new Error("输入手机号"));
                }
              },
            },
          ]}
        >
          {(fields, { add, remove }, { errors }) => (
            <>
              {fields.map((field, index) => (
                <Form.Item
                  {...(index === 0
                    ? formItemLayout
                    : formItemLayoutWithOutLabel)}
                  label={index === 0 ? "手机号码" : ""}
                  required={false}
                  key={field.key}
                >
                  <Form.Item
                    {...field}
                    validateTrigger={["onChange", "onBlur"]}
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: "输入手机号",
                      },
                      {
                        validator: handleCheckPhone,
                      },
                    ]}
                    noStyle
                  >
                    <Input
                      placeholder="请输入手机号"
                      style={{ width: "60%" }}
                    />
                  </Form.Item>
                  {fields.length > 1 ? (
                    <MinusCircleOutlined
                      className="dynamic-delete-button"
                      onClick={() => remove(field.name)}
                    />
                  ) : null}
                </Form.Item>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  style={{ width: "60%" }}
                  icon={<PlusOutlined />}
                >
                  添加手机号
                </Button>
                <Form.ErrorList errors={errors} />
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form>
    </Modal>
  );
};
export default observer(WhitePhoneAddDialog);
